import type { FeedActor } from '@/types'

export function relativeTime(iso: string): string {
  const then = new Date(iso).getTime()
  const now = Date.now()
  const diff = Math.max(0, now - then)
  const min = Math.floor(diff / 60000)
  if (min < 1) return 'just now'
  if (min < 60) return `${min}m ago`
  const hr = Math.floor(min / 60)
  if (hr < 24) return `${hr}h ago`
  const day = Math.floor(hr / 24)
  if (day < 7) return `${day}d ago`
  return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

export function actorInitials(actor: FeedActor): string {
  const first = actor.first_name?.[0] ?? ''
  const last = actor.last_name?.[0] ?? ''
  return (first + last) || actor.username[0].toUpperCase()
}

export function actorName(actor: FeedActor): string {
  if (actor.first_name && actor.last_name) return `${actor.first_name} ${actor.last_name}`
  return `@${actor.username}`
}

export function formatEventDate(iso: string): string {
  const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(iso)
  const d = new Date(isDateOnly ? `${iso}T12:00:00` : iso)
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}
